/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PalReauthNoteAction } from './PalReauthNoteAction';
import {
    PalReauthNoteActionFromJSON,
    PalReauthNoteActionFromJSONTyped,
    PalReauthNoteActionToJSON,
    PalReauthNoteActionToJSONTyped,
} from './PalReauthNoteAction';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';

/**
 * 
 * @export
 * @interface PalReauthNote
 */
export interface PalReauthNote {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    action: PalReauthNoteAction;
    /**
     * Empty for a `removed` entry.
     */
    text: string;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    created_by_user?: PalAuthSubmissionStatusUpdatedByUser;
}



/**
 * Check if a given object implements the PalReauthNote interface.
 */
export function instanceOfPalReauthNote(value: object): value is PalReauthNote {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function PalReauthNoteFromJSON(json: any): PalReauthNote {
    return PalReauthNoteFromJSONTyped(json, false);
}

export function PalReauthNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'action': PalReauthNoteActionFromJSON(json['action']),
        'text': json['text'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'created_by_user': json['created_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['created_by_user']),
    };
}

export function PalReauthNoteToJSON(json: any): PalReauthNote {
    return PalReauthNoteToJSONTyped(json, false);
}

export function PalReauthNoteToJSONTyped(value?: PalReauthNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'action': PalReauthNoteActionToJSON(value['action']),
        'text': value['text'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'created_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['created_by_user']),
    };
}

